/**
 * notFound: what a loader throws for an address that names nothing. The
 * layout's boundary (RouteErrorBoundary) shows it as Page Not Found.
 */
import { data } from 'react-router'

/** The status the layout's boundary shows as Page Not Found. */
const NOT_FOUND_STATUS = 404

export const notFound = () => data(null, { status: NOT_FOUND_STATUS })
